import React, { useState } from 'react';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import { services } from '../../constants/data';

const Services = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  const categories = ['all', 'rentals', 'parts', 'services', 'sales', 'training'];
  
  const filteredServices = selectedCategory === 'all' 
    ? services 
    : services.filter(service => service.category === selectedCategory);

  return (
    <div className="py-5">
      <div className="container-fluid">
        {/* Page Header */}
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3">Products & Services</h1>
          <p className="lead text-muted">Complete forklift solutions tailored to your industrial needs</p>
        </div>

        {/* Category Filter */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
              {categories.map(category => (
                <button
                  key={category}
                  className={`btn ${selectedCategory === category ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category === 'all' ? 'All Services' : category.charAt(0).toUpperCase() + category.slice(1)}
                </button>
              ))}
            </div>
            <div className="text-center">
              <div className="input-group mx-auto" style={{ maxWidth: '500px' }}>
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search specific services or parts..."
                  onChange={(e) => {
                    // Implement search functionality here
                  }}
                />
                <button className="btn btn-primary" type="button">
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row g-4">
          {filteredServices.map(service => (
            <div key={service.id} className="col-md-6 col-lg-4">
              <ServiceCard service={service} />
            </div>
          ))}
        </div>

        {/* Additional Information */}
        <div className="row mt-5 pt-5">
          <div className="col-lg-6 mb-4">
            <div className="bg-primary text-white p-5 rounded">
              <h3 className="mb-3">Need Custom Solutions?</h3>
              <p className="mb-4">We provide tailored forklift solutions for specific industry requirements.</p>
              <a href="tel:+919876543210" className="btn btn-light">
                <i className="bi bi-telephone me-2"></i>Call for Custom Quote
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-light p-5 rounded border">
              <h3 className="mb-3">Maintenance Contracts</h3>
              <p className="text-muted mb-4">Save up to 30% with our annual maintenance contracts. Includes regular servicing, priority support, and discounted parts.</p>
              <div className="d-flex flex-wrap gap-2">
                <span className="badge bg-success">Monthly Plans</span>
                <span className="badge bg-primary">Quarterly Plans</span>
                <span className="badge bg-info">Annual Plans</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;